import currencyList from './currencyList'
import {AdyenError} from './AdyenError'
const INVALID_CURRENCY_ERROR = 'invalid currency!'

// converts the currency value for the Adyen Checkout API
export function getCurrencyValueForApi(amount, currencyCode) {
    const currency = currencyList.find((currency) => currency.Code === currencyCode)
    if (!currency) {
        throw new AdyenError(`${INVALID_CURRENCY_ERROR}: "${currencyCode}"`, 400, 'wrongCurrency')
    }
    return Math.round(amount * Math.pow(10, currency.Decimals))
}

// converts the currency value from minor units to major units
export function convertCurrencyValueToMajorUnits(amount, currencyCode) {
    const currency = currencyList.find((currency) => currency.Code === currencyCode)
    if (!currency) throw new Error(INVALID_CURRENCY_ERROR)
    return amount / Math.pow(10, currency.Decimals)
}
